import ConceptLink from '../core/ConceptLink';
import PropTypes from 'prop-types';
import React from 'react';
import { DropTarget } from 'react-dnd';

const Types = {
  ANNOTATION: 'annotation',
  XLLABEL: 'xllabel'
};

const target = {
  drop(props, monitor) {
    const item = monitor.getItem();
    if (item.type === "Annotation") {
      props.onAddToConcept(props.id, item.annotationLabel, item.annotationLang);
    }
    else {
      props.onAddLabelToConcept(props.id, item.labelId, item.labelLang);
    }
    return {
      handled: true
    };
  }
};

function collectTarget(connect, monitor) {
  return {
    connectDropTarget: connect.dropTarget(),
    isOver: monitor.isOver()
  };
}

class DropConceptLink extends React.Component {

  render() {

    const { isOver, connectDropTarget } = this.props;

    return connectDropTarget(
      <div style={{ display: 'inline-block', maxWidth: '100%' }}>
        <ConceptLink {...this.props} highlight={isOver} />
      </div>
    );
  }
}

DropConceptLink.propTypes = {
  onAddToConcept: PropTypes.func.isRequired,
  onAddLabelToConcept: PropTypes.func.isRequired
};

export default DropTarget([Types.ANNOTATION, Types.XLLABEL], target, collectTarget)(DropConceptLink);